export default {
    actions: {
        async getAllPartnerblocks(ctx) {
            const axios = require("axios").default;
            let configs = null;
            let getConfig = axios({
                url: "../../config.json",
            }).then((respose) => {
                configs = respose.data;
                return configs;
            });

            const config = await getConfig;
            let url = "";

            for (let i = 0; i < config.length; i++) {
                if (config[i].name === "api") {
                    url = config[i].ip + "/GetAllPartnerblocks";
                }
            }
            const getPartnerblocksAxios = async (url, ctx) => {
                let count = 0;
                await axios.get(url)
                    .then((response) => {

                        //     console.log(response);
                        //     console.log(ctx);
                        if (response.status == "200") {
                            // console.log(response);
                            ctx.commit("updateAllPartnerblocks", response.data);
                            // ctx.commit("loadp", response.data);
                        }
                    })
                    .catch(async (error) => {
                        console.log(error);
                        if (count > 3) {
                            await getPartnerblocksAxios(url);
                        }
                        count++;
                    });
            }

            await getPartnerblocksAxios(url, ctx);
        }
    },
    mutations: {
        updateAllPartnerblocks(state, partnerblocks) {
            state.partnerblocks = partnerblocks;
        },        

    },
    state: {
        partnerblocks: [],
        
    },
    getters: {
        getPartnerblocks(state) {
            return state.partnerblocks;
        },
    }

}